import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TooltipFocusHandlerDirective } from '@shared/directives/tooltip-focus-handler.directive';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-ellipsis-tooltip',
    standalone: true,
    imports: [TooltipModule, TooltipFocusHandlerDirective],
    templateUrl: './ellipsis-tooltip.component.html',
    styleUrls: ['./ellipsis-tooltip.component.scss'],
    host: { style: 'display: contents' },
})
export class EllipsisTooltipComponent {
    @ViewChild('contentTemplate') contentTemplate: ElementRef<HTMLParagraphElement> | null = null;

    @Input({ required: true }) paragraphId!: string;
    @Input({ required: false }) ellipsisNumberOfRows = 1;
    @Input({ required: false }) tooltipDelayTime = 0;
    @Input({ required: false }) disableTooltip = false;
    @Input({ required: false }) showTooltip = false;
    @Input({ required: false }) isElementFocusable = true;
    @Input({ required: false }) tooltipPosition: string = 'right';

    pTooltip: string | undefined = undefined;

    shouldShowTooltip(): void {
        const el = this.contentTemplate?.nativeElement;
        if (this.pTooltip || !el) {
            return;
        }
        this.pTooltip =
            (!this.disableTooltip && el.offsetHeight < el.scrollHeight) || this.showTooltip
                ? (el.textContent ?? undefined)
                : undefined;
    }
}
